import { BydLoginInterface } from '../interfaces/byd-login.interface';

export class BydLogin {
  /**
   * User login
   */
  public login: string;

  /**
   * User password
   */
  public pwd: string;

  /**
   * User api scope
   */
  public scope: string;

  /**
   * Creates an instance of BydLogin.
   *
   * @param jsonData the user login data
   */
  constructor(jsonData: BydLoginInterface) {
    this.login = jsonData.login;
    this.pwd = jsonData.pwd;
    this.scope = jsonData.scope;
  }
}
